import type { InsuranceDashboardResponse } from '../types/insuranceDashboard';
import baseApi from './baseApi';

interface GetInsuranceDashboardParams {
  month?: number;
  year?: number;
  businessUnitId?: number;
}

const insuranceDashboardApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getInsuranceDashboardSummary: build.query<InsuranceDashboardResponse, GetInsuranceDashboardParams>({
      query: (params) => ({
        url: '/insurance-dashboard/summary',
        method: 'GET',
        params,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetInsuranceDashboardSummaryQuery } = insuranceDashboardApi;
